import React, { Component } from 'react'
import { InputNumber } from 'hljd'

export default class InputPrice extends Component {
  render() {
    const { value, onChange, disabled, onClick, placeholder } = this.props

    return (
      <div onClick={onClick}>
        <InputNumber
          disabled={disabled}
          placeholder={placeholder || '请输入参考价格'}
          style={{ width: 380 }}
          onChange={val => onChange(val)}
          value={value}
        />
        <span style={{ marginLeft: 10 }}>元</span>
      </div>
    )
  }
}
